'use strict';

const _ = require('underscore');
const Mn = require('backbone.marionette');
const Tooltip = require('common/ui/view/behavior/tooltip');
const Template = require('process/ui/template/action/date.hbs');

module.exports = Mn.View.extend({
    template: Template,
    modelEvents: {
        change: 'render'
    },
    behaviors: [Tooltip],
    templateContext: function() {
        return {
            isInitial: this.model.getCurrentState().isInitial(),
            isActive: this.model.active(),
            startIsDelayed: this.model.startIsDelayed(),
            startDelay: {
                lastDays: this.model.getStartLastDays(),
                delayedDays: -this.model.getStartLastDays(),
            },
            endIsDelayed: this.model.endIsDelayed(),
            endDelay: {
                lastDays: this.model.getEndLastDays(),
                delayedDays: -this.model.getEndLastDays(),
            }
        }
    }
});



// WEBPACK FOOTER //
// ./process/ui/view/action/date.js